module.exports = __webpack_public_path__ + "static/media/search.dde9e5eb.png";